import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { onMounted, watch, computed, ref } from '@nuxtjs/composition-api'
import { useTipsModel } from './../model'
import { useCustomLogicModel } from '@shared/model'
import { useRestaurantModel } from '@entities/restaurant'
import type { IData } from './../model/types'
import TipsProfile from './TipsProfile.vue'
import TipsCustom from './TipsCustom.vue'
import TipsPercents from './TipsPercents.vue'
import TipsInfo from './TipsInfo.vue'
import { convertRole } from './../utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'TipsBlock',
  props: {
  data: {
    type: Object as PropType<IData>,
    required: true
  },
  sumorders: {
    type: Number,
    required: true
  }
},
  setup(__props) {

const props = __props

const tipsModel = useTipsModel()
const customLogicModel = useCustomLogicModel()
const restaurantModel = useRestaurantModel()



const tabs = ref<string[]>([])
const tabsReverse = ref<string[]>([])

const tipsError = computed(() => {
  let text = ''
  if (tipsModel.tipsError) {
    text = 'Минимальная сумма чаевых 49 '
  }
  if (tipsModel.tipsSum > 50000) {
    text = 'Максимальная сумма чаевых 50 000 '
  }
  return {
    active: tipsModel.tipsError || tipsModel.tipsSum > 50000,
    text
  }
})

const updateTipsForAllRoles = () => {
  const roles = ['kitchener', 'hookah', 'barman', 'barista', 'sommelier']

  roles.forEach((role) => {
    if (tipsModel.tips[role] && tipsModel.tips[role].active) {
      const tips = {
        role,
        sum: 0,
        selectedPercent: 0,
        manualTips: false,
        hideActiveStylePercent: false
      }
      tipsModel.changeTips(tips)
    }
  })
}

const recountWaiterTips = (data: IData, sumorders: number) => {
  if (tipsModel.tips.waiter.active && data.waiter.card_verification && data.tipsType === 'TAPPER') {
    const waiterTips = {
      role: 'waiter',
      sum: 0,
      selectedPercent: 0,
      manualTips: false,
      hideActiveStylePercent: false
    }
    // const numberPercents = customLogicModel.list.percentRest ? 15 : 10

    let numberPercents = 10 // Значение по умолчанию

    if (customLogicModel.list.percentRest) {
      numberPercents = 15
    } else if (customLogicModel.list.percentRestTwenty) {
      numberPercents = 20
    }

    // **Если выбраны 0% чаевых у официанта, обнуляем чаевые у всех**
    if (waiterTips.selectedPercent === 0 && customLogicModel.list.zeroTips) {
      updateTipsForAllRoles() // Обнуляем чаевые у всех
    }

    // if (sumorders > 0) {
    //   waiterTips.sum = (sumorders / 100) * waiterTips.selectedPercent
    //   waiterTips.manualTips = false
    //   waiterTips.hideActiveStylePercent = false
    // }
    //
    // tipsModel.changeTips(waiterTips)

    if (sumorders === 0) {
      waiterTips.sum = 0
      waiterTips.selectedPercent = numberPercents
      waiterTips.manualTips = false
      waiterTips.hideActiveStylePercent = true
    }

    if ((sumorders < 490 && sumorders > 0) && !tipsModel.tips.waiter.manualTips) {
      waiterTips.sum = 49
      waiterTips.selectedPercent = numberPercents
      waiterTips.manualTips = false
      waiterTips.hideActiveStylePercent = true
    }

    if ((sumorders < 490 && sumorders > 0) && tipsModel.tips.waiter.manualTips) {
      waiterTips.sum = tipsModel.tips.waiter.sum
      waiterTips.selectedPercent = tipsModel.tips.waiter.selectedPercent
      waiterTips.manualTips = true
      waiterTips.hideActiveStylePercent = false
    }

    if (sumorders >= 490 && !tipsModel.tips.waiter.manualTips) {
      waiterTips.sum = (sumorders / 100 * tipsModel.tips.waiter.selectedPercent)
      waiterTips.selectedPercent = tipsModel.tips.waiter.selectedPercent
      waiterTips.manualTips = false
      waiterTips.hideActiveStylePercent = false
    }

    if (sumorders >= 490 && tipsModel.tips.waiter.manualTips) {
      waiterTips.sum = tipsModel.tips.waiter.sum
      waiterTips.selectedPercent = tipsModel.tips.waiter.selectedPercent
      waiterTips.manualTips = true
      waiterTips.hideActiveStylePercent = false
    }

    if (data.fee_type === 'WITHOUT_FEE') {
      if ((sumorders < 392 && sumorders > 0) && !tipsModel.tips.waiter.manualTips) {
        waiterTips.sum = 49
        waiterTips.selectedPercent = 12.5
        waiterTips.manualTips = false
        waiterTips.hideActiveStylePercent = true
      }

      if ((sumorders < 392 && sumorders > 0) && tipsModel.tips.waiter.manualTips) {
        waiterTips.sum = tipsModel.tips.waiter.sum
        waiterTips.selectedPercent = tipsModel.tips.waiter.selectedPercent
        waiterTips.manualTips = true
        waiterTips.hideActiveStylePercent = false
      }

      if (sumorders >= 392 && !tipsModel.tips.waiter.manualTips) {
        waiterTips.sum = (sumorders / 100 * tipsModel.tips.waiter.selectedPercent)
        waiterTips.selectedPercent = tipsModel.tips.waiter.selectedPercent
        waiterTips.manualTips = false
        waiterTips.hideActiveStylePercent = false
      }

      if (sumorders >= 392 && tipsModel.tips.waiter.manualTips) {
        waiterTips.sum = tipsModel.tips.waiter.sum
        waiterTips.selectedPercent = tipsModel.tips.waiter.selectedPercent
        waiterTips.manualTips = true
        waiterTips.hideActiveStylePercent = false
      }
    }
    // Дефолтные чаевые для официанта waiterPercents
    if (customLogicModel.list.waiterPercents && props.data.waiter) {
      const sum = sumorders / 100 * 5
      waiterTips.selectedPercent = 5
      waiterTips.sum = sum > 49 ? sum : 49
      waiterTips.hideActiveStylePercent = !(sum > 49)
    }
    tipsModel.changeTips(waiterTips)
  }
}

const isTeamActive = computed(() => {
  if (Array.isArray(props.data.team)) {
    return props.data.team.length > 0 && props.data.team.some(t => t.active)
  }
  return props.data.team?.active ?? false
})

const shouldShowTab = computed(() => (item: string) => {
  if (item === 'waiter') {
    // Показывать официанта если:
    // - У официанта есть верификация карты ИЛИ
    // - У официанта нет верификации И команда не активна
    return props.data.waiter?.card_verification ||
      (!props.data.waiter?.card_verification && !isTeamActive.value)
  }

  if (item === 'team') {
    // Показывать команду если:
    // - У официанта нет верификации И команда активна
    return !props.data.waiter?.card_verification && isTeamActive.value
  }

  return true
})

const shouldShowAmount = computed(() => (item: string) => {
  if (item === 'waiter') {
    return props.data.waiter?.card_verification && props.data.tipsType === 'TAPPER'
  }
  return item !== 'waiter'
})

const indexOfSelectedTab = computed(() => {
  return tabs.value.indexOf(activeTab.value)
})

const waiterPurposeCollected = computed<number>(() => {
  if (!props.data.waiter || typeof props.data.waiter.purpose_collected !== 'number') {
    return 0
  }
  return props.data.waiter.purpose_collected
})

const waiterPurposeAmount = computed<number | null>(() => {
  if (!props.data.waiter || typeof props.data.waiter.purpose_amount !== 'number') {
    return null
  }
  return props.data.waiter.purpose_amount
})

const waiterPurposeRemaining = computed<number>(() => {
  if (waiterPurposeAmount.value === null) {
    return 0
  }
  return Math.max(waiterPurposeAmount.value - waiterPurposeCollected.value, 0)
})

const waiterPurposeProgress = computed<number>(() => {
  if (!waiterPurposeAmount.value || waiterPurposeAmount.value <= 0) {
    return 0
  }
  const percent = (waiterPurposeCollected.value / waiterPurposeAmount.value) * 100
  return Math.min(Math.max(percent, 0), 100)
})

const formatAmount = (value: number | null): string => {
  if (value === null) {
    return '0'
  }
  return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(Math.round(value / 100))
}

const activeTab = ref<string>('')

const recountTips = (role: string, sumorders: number) => {
  if (tipsModel.tips.hookah.active) {
    const newTips = {
      role,
      sum: 0,
      selectedPercent: 0,
      manualTips: false,
      hideActiveStylePercent: false
    }

    if (sumorders === 0) {
      newTips.sum = 0
      newTips.selectedPercent = tipsModel.tips[role].selectedPercent
      newTips.manualTips = false
      newTips.hideActiveStylePercent = true
    }

    if (sumorders > 0) {
      newTips.sum = (sumorders / 100 * tipsModel.tips[role].selectedPercent)
      newTips.selectedPercent = tipsModel.tips[role].selectedPercent
      newTips.manualTips = false
      newTips.hideActiveStylePercent = false
    }
    tipsModel.changeTips(newTips)
  }
}

const applyTeamTips = (sumorders: number) => {
  if (!tipsModel.tips.team.active || !shouldShowTab.value('team')) {
    return
  }

  const selectedPercent = tipsModel.tips.team.selectedPercent
  const manualTips = tipsModel.tips.team.manualTips

  if (manualTips) {
    tipsModel.changeTips({
      role: 'team',
      sum: tipsModel.tips.team.sum,
      selectedPercent,
      manualTips: true,
      hideActiveStylePercent: false
    })
    return
  }

  if (sumorders === 0) {
    tipsModel.changeTips({
      role: 'team',
      sum: 0,
      selectedPercent,
      manualTips: false,
      hideActiveStylePercent: true
    })
    return
  }

  if (sumorders < 490) {
    tipsModel.changeTips({
      role: 'team',
      sum: 49,
      selectedPercent: 10,
      manualTips: false,
      hideActiveStylePercent: true
    })
    return
  }

  tipsModel.changeTips({
    role: 'team',
    sum: sumorders / 100 * selectedPercent,
    selectedPercent,
    manualTips: false,
    hideActiveStylePercent: false
  })
}

watch(() => props.sumorders, () => {
  recountWaiterTips(props.data, props.sumorders)
  recountTips('hookah', props.sumorders)
  recountTips('barista', props.sumorders)
  recountTips('barman', props.sumorders)
  recountTips('kitchener', props.sumorders)
  recountTips('sommelier', props.sumorders)
  applyTeamTips(props.sumorders)
})

watch(() => tipsModel.tips.waiter.sum, (newSum) => {
  if (newSum === 0 && customLogicModel.list.zeroTips) {
    updateTipsForAllRoles()
  }
})

onMounted(async () => {
  // Дефолтные чаевые для кухни kitchenPercents
  if (customLogicModel.list.kitchenPercents && props.data.kitchener && props.data.kitchener?.active) {
    tipsModel.changeDefaultTips({
      role: 'kitchener',
      percents: [0, 2.5, 5, 10],
      selectedPercent: 2.5
    })
    const sum = (props.sumorders / 100 * 2.5)
    tipsModel.changeTips({
      role: 'kitchener',
      sum,
      selectedPercent: 2.5,
      manualTips: false,
      hideActiveStylePercent: false
    })
  }

  // Дефолтные чаевые для официанта waiterPercents
  if (customLogicModel.list.waiterPercents && props.data.waiter) {
    tipsModel.changeDefaultTips({
      role: 'waiter',
      percents: [0, 5, 10, 15, 20],
      selectedPercent: 5
    })
    const sum = (props.sumorders / 100 * 5)
    tipsModel.changeTips({
      role: 'waiter',
      sum: sum > 49 ? sum : 49,
      selectedPercent: sum > 49 ? 5 : 0,
      manualTips: !(sum > 49),
      hideActiveStylePercent: false
    })
  }
  await tipsModel.updateData(props.data)
  tipsModel.firstRecountWaiterTips({
    percentRest: customLogicModel.list.percentRest,
    percentRestZero: customLogicModel.list.percentRestZero,
    percentRestFive: customLogicModel.list.percentRestFive,
    percentRestTwenty: customLogicModel.list.percentRestTwenty,
    percentKitchenFive: customLogicModel.list.kitchenPercentFive,
    data: { ...props.data, sumorders: props.sumorders },
    newLogic: customLogicModel.list.withoutNewLogicTips,
    restCode: restaurantModel.code
  })

  if (tipsModel.tips.team && tipsModel.tips.team.active && shouldShowTab.value('team')) {
    tipsModel.changeTips({
      role: 'team',
      sum: 0,
      selectedPercent: 10,
      manualTips: false,
      hideActiveStylePercent: false
    })
    applyTeamTips(props.sumorders)
    tabs.value.unshift('team') // unshift добавляет элемент в начало массива (индекс 0)
  }

  for (const item in tipsModel.tips) {
    if (item !== 'team' && tipsModel.tips[item].active && shouldShowTab.value(item)) {
      tabs.value.push(item)
    }
  }

  if (tabs.value.includes('team') && shouldShowTab.value('team')) {
    tipsModel.changeTab('team')
  } else if (shouldShowTab.value('waiter') && props.data.waiter &&
    props.data.waiter.waiter_status === 'VERIFIED') {
    tipsModel.changeTab('waiter')
  } else if (props.data.hookah && shouldShowTab.value('hookah')) {
    tipsModel.changeTab('hookah')
  } else if (props.data.kitchener) {
    tipsModel.changeTab('kitchener')
  } else if (props.data.barman) {
    tipsModel.changeTab('barman')
  } else if (props.data.barista) {
    tipsModel.changeTab('barista')
  } else if (props.data.sommelier) {
    tipsModel.changeTab('sommelier')
  } else {
    tipsModel.changeTab('')
  }
  const copyArr = [...tabs.value]
  tabsReverse.value = copyArr.reverse()
  // activeTab.value = tabs.value[0]
  // Приоритет: team -> текущая вкладка из tipsModel -> первая доступная вкладка
  const preferredTab = tabs.value.includes('team') ? 'team' : (tipsModel.tab || tabs.value[0])
  activeTab.value = tabs.value.includes(preferredTab) ? preferredTab : tabs.value[0]
})


return { __sfc: true,tipsModel, customLogicModel, restaurantModel, props, tabs, tabsReverse, tipsError, updateTipsForAllRoles, recountWaiterTips, isTeamActive, shouldShowTab, shouldShowAmount, indexOfSelectedTab, waiterPurposeCollected, waiterPurposeAmount, waiterPurposeRemaining, waiterPurposeProgress, formatAmount, activeTab, recountTips, applyTeamTips, TipsProfile, TipsCustom, TipsPercents, TipsInfo, convertRole }
}

})